export default __webpack_public_path__ + "static/media/maskekko.d3ea8a62.gif";